import { useTranslation } from "react-i18next";
import { Quotation } from "../../types/quotations/Quotation";
import { quotationsSelector } from "../../features/quotationsSlice";
import { useAppSelector } from "../../redux/hooks";
import { QuotationDetailsLoading } from "./QuotationDetailsLoading";
import { Card } from "primereact/card";
import { CardHeader } from "./CardHeader";
import { Divider } from "primereact/divider";
import { getInspectionDate } from "../../utils/dates";
import "./QuotationDetails.css";
import { QuoteActionsBody} from "../inspections-table/QuoteActionsBody";
import { labelAndValue } from "./LabelAndValue";
import { QuotationStatus } from "../../constants/QuotationConstants";

export interface QuotationDetailsProps {
    quotation?: Quotation;
}

export const QuotationDetails = () => {
    const {SelectedQuotation} = useAppSelector(quotationsSelector);
    const { t } = useTranslation("locale");

    if (!SelectedQuotation) {
        return <QuotationDetailsLoading />;
    }

    return (
        <Card header={CardHeader(t("quotations.details.title"))}>
            <div
                id="quotation-details-panel"
                data-cy="quotation-details-panel"
                className="col-12"
            >
                <div className="grid">
                    {labelAndValue(t("quotations.details.vesselName"), SelectedQuotation.vesselName, "details-vessel-name", "quotation-details", true)}
                    {labelAndValue(t("quotations.details.imo"), SelectedQuotation.vesselImo, "quotation-details",  "details-vessel-imo")}
                    {labelAndValue(t("quotations.details.vesselType"), SelectedQuotation.vesselType, "quotation-details",  "details-vessel-type")}
                    <Divider className="mb-5" />
                    {labelAndValue(t("quotations.details.quotationNumber"), SelectedQuotation.quotationNumber, "details-quotation-number", "quotation-details",  true)}
                    {labelAndValue(t("quotations.details.statusName"), SelectedQuotation.statusName, "details-status-name", "quotation-details", )}
                    {labelAndValue(t("quotations.details.statusDate"), getInspectionDate(SelectedQuotation.statusDate.toString(), undefined), "details-status-date", "quotation-details", )}
                    <Divider className="mb-5" />
                    {labelAndValue(t("quotations.details.inspectionType"), SelectedQuotation.inspectionType, "details-inspection-type", "quotation-details",  true)}
                    {labelAndValue(t("quotations.details.location"), SelectedQuotation.port + ", " + SelectedQuotation.country, "details-location", "quotation-details", )}
                    {labelAndValue(t("quotations.details.dates"), getInspectionDate(SelectedQuotation.quotationDateFrom.toString(), SelectedQuotation.quotationDateTo?.toString()), "details-dates", "quotation-details", )}
                </div>

                <div className="action-div">
                    {SelectedQuotation.status !== QuotationStatus.ORDERED && QuoteActionsBody(t,{
                        vesselName : SelectedQuotation.vesselName,
                        inspectionType: SelectedQuotation.inspectionType,
                        quotationNumber: SelectedQuotation.quotationNumber,
                        id: SelectedQuotation.id,
                        startDate: new Date(SelectedQuotation.quotationDateFrom as string),
                        endDate: SelectedQuotation.quotationDateTo == null ? null : new Date(SelectedQuotation.quotationDateTo as string),
                        imo: SelectedQuotation.vesselImo,
                        vesselType: SelectedQuotation.vesselType,
                        location: SelectedQuotation.port + ", " + SelectedQuotation.country,
                        countryCode: SelectedQuotation.CountryCode,
                        locationId: SelectedQuotation.locationId,
                        inspectionTypeId: SelectedQuotation.inspectionTypeId,
                        quotationStatus: SelectedQuotation.status
                    })}
                </div>

                </div>
        </Card>
)
}
